import { Illustration, Pictogram } from '@eti/components';
import { useSiteContext } from '@eti/providers';
import { useMediaQuery } from 'usehooks-ts';
import { breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { getProductIllustrationId, getProductPictogramId } from '../../../common/utils/icon/getProductImageryIds';
import { jsx as _jsx } from "react/jsx-runtime";
const baggageIllustrationStyles = css`
  min-width: 30px;
`;
const BaggageIllustration = ({
  isRTL,
  productName
}) => {
  const {
    brand: {
      code: brand
    }
  } = useSiteContext();
  const isMobileScreen = useMediaQuery(`(max-width: ${breakpoints._768})`);
  const imageId = isMobileScreen ? getProductPictogramId(productName, isRTL) : getProductIllustrationId(productName, isRTL);
  return isMobileScreen ? /*#__PURE__*/_jsx(Pictogram, {
    brand: brand,
    className: baggageIllustrationStyles,
    "data-testid": `${productName}-pictogram`,
    id: imageId
  }) : /*#__PURE__*/_jsx(Illustration, {
    brand: brand,
    className: baggageIllustrationStyles,
    "data-testid": `${productName}-illustration`,
    id: imageId
  });
};
export default BaggageIllustration;
//# sourceMappingURL=BaggageIllustration.js.map